module.exports = {"id":"163631","name":"Leighton Baines","rating":"80","photo":"./data/images/photos/4/163631.png","club":{"name":"Everton","logo":"./data/images/clubs/Everton.png"},"positions":["DG","DLG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LeightonBaines0.json
// module id = 2470
// module chunks = 0